"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AttachmentsStore = _interopRequireDefault(require("crm_ui/attachments/data/AttachmentsStore"));

var _immutable = require("immutable");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _default = {
  stores: [_AttachmentsStore.default],
  deref: function deref(_ref) {
    var engagement = _ref.engagement;

    if (!engagement || !engagement.get('attachments').size) {
      return (0, _immutable.List)();
    }

    var attachmentIds = engagement.get('attachments');
    attachmentIds = attachmentIds.map(function (attachment) {
      return attachment.get('id');
    }).filter(_identity.default);
    return _AttachmentsStore.default.get(attachmentIds).filter(_identity.default);
  }
};
exports.default = _default;
module.exports = exports.default;